import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Menu } from 'antd';
import { isUserMultiTenant } from "../../../swzutils/UserPermissionsUtil";
import { conditionFilter } from "../../../swzutils";
import { useAppSelector } from "../../../store";
import { loggedInUserSelector } from "../../../store/slice/auth";
const PermissionsMenu = (props) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const onMenuItemClicked = (menuItem) => {
        if (props.onMenuItemSelected) {
            props.onMenuItemSelected(menuItem);
        }
        if (typeof menuItem.onClick == "function") {
            menuItem.onClick();
        }
    };
    const subTruxAdminOrMultiTenantUser = isUserMultiTenant(loggedInUser);
    const buildMenuItem = (menuItem) => {
        let route;
        if (subTruxAdminOrMultiTenantUser) {
            route = menuItem.route;
        }
        else {
            if (menuItem.route && loggedInUser && loggedInUser.tenants?.length) {
                const firstTenant = loggedInUser?.tenants[0];
                route = menuItem.route.replace(/{tenantId}/gi, firstTenant?.id ? '' + firstTenant.id : '');
            }
        }
        return {
            key: menuItem.key,
            label: _jsxs("a", { target: menuItem.target, href: route, onClick: () => onMenuItemClicked(menuItem), children: [menuItem.icon, _jsxs("span", { className: "nav-text", children: [" ", menuItem.text] })] })
        };
    };
    const permissionFilter = (menuItem) => {
        if (loggedInUser && loggedInUser.permissions && menuItem.permissions) {
            if (menuItem.route && menuItem.route.indexOf("{tenantId}") >= 0 && subTruxAdminOrMultiTenantUser) {
                return false;
            }
            return loggedInUser.permissions.filter(Set.prototype.has, new Set(menuItem.permissions)).length > 0;
        }
        return (!(menuItem.permissions && menuItem.permissions.length > 0));
    };
    const availableMenuItems = props.menuItems
        .filter(permissionFilter)
        .filter(conditionFilter)
        .map((menuItem) => {
        const subMenuItems = menuItem.subMenu && menuItem.subMenu
            .filter(permissionFilter)
            .filter(conditionFilter)
            .map((subMenu) => {
            return buildMenuItem(subMenu);
        });
        // If this menu has a submenu but the user does not have permission to any items within it then do not show it.
        if (menuItem.subMenu && menuItem.subMenu.length && (!subMenuItems || !subMenuItems.length)) {
            return;
        }
        if (subMenuItems && subMenuItems.length) {
            return {
                key: menuItem.key,
                label: _jsxs("span", { children: [menuItem.icon, " ", _jsx("span", { className: "nav-text", children: menuItem.text })] }),
                children: subMenuItems
            };
        }
        return buildMenuItem(menuItem);
    })
        .filter(it => !!it);
    if (!availableMenuItems || availableMenuItems.length === 0) {
        return null;
    }
    return (_jsx(Menu, { mode: props.mode ?? "vertical", theme: props.theme ?? "light", items: availableMenuItems, prefixCls: props.prefixCls, inlineIndent: props.inlineIndent ?? 24, defaultSelectedKeys: props.defaultSelectedKeys, defaultOpenKeys: props.defaultOpenKeys }));
};
export default PermissionsMenu;
